module.exports = __webpack_public_path__ + "img/certificado-LAASON_2025.f35aa1c1.jpg";